import React from 'react'
import cx from 'classnames'
import Navigation from '/js/views/shared/components/navigation'
import Header from '/js/views/shared/components/header'
import Hero from '/js/views/shared/components/hero'
import Intro from '/js/views/shared/components/intro'
import Image from '/js/views/shared/components/contentParticles/image'
import Video from '/js/views/shared/components/contentParticles/video'
import DefaultClasses from '/js/util/defaultClasses'
import { generateSiblingPages } from '/js/util'
import DottedLine from '/img/svg/dotted-line'
import ArrowForward from '/img/svg/arrow'
import ArrowBack from '/img/svg/arrow-back'
import CameraIcon from '/img/svg/camera-icon'
import { Citations } from '../components/citations'

class LetterPageLayout extends React.Component {
  renderPagination() {
    const { currentPage, routes } = this.props
    const siblingPages = generateSiblingPages(currentPage, routes)
    const { prevPage, nextPage } = siblingPages

    return (
      <div className="w-full flex flex-wrap justify-center mb-90">
        <a
          className={`flex-grow md:flex-grow-0 mr-15 ${DefaultClasses.button} ${DefaultClasses.buttonBlue}`}
          href={prevPage.url}
        >
          <ArrowBack className="mr-10" />
          {prevPage.title}
        </a>
        <a
          className={`flex-grow md:flex-grow-0 ${DefaultClasses.button} ${DefaultClasses.buttonBlue}`}
          href={nextPage.url}
        >
          {nextPage.title}
          <ArrowForward className="ml-10" />
        </a>
      </div>
    )
  }

  renderParagraphs(section, sectionIndex) {
    const { theme } = this.props

    return section.paragraphs.map((paragraph, index) => {
      if (Object.keys(paragraph)[0] === 'title') {
        return (
          <h3
            key={`title-${sectionIndex}${index}`}
            className={`uppercase font-condensed text-24 ${theme.textColor} mb-10`}
            dangerouslySetInnerHTML={{ __html: paragraph.title }}
          />
        )
      }

      if (Object.keys(paragraph)[0] === 'text') {
        return (
          <p
            key={`paragraph-${sectionIndex}${index}`}
            className="mb-32 tracking-wide"
            dangerouslySetInnerHTML={{ __html: paragraph.text }}
          />
        )
      }

      if (Object.keys(paragraph)[0] === 'citations') {
        return (
          <Citations
            className="mb-32"
            key={`citation-${sectionIndex}${index}`}
            citations={paragraph.citations}
          />
        )
      }

      if (Object.keys(paragraph)[0] === 'introText') {
        return (
          <p
            key={`paragraph-${sectionIndex}${index}`}
            className="text-22 leading-spacey"
            dangerouslySetInnerHTML={{ __html: paragraph.introText }}
          />
        )
      }

      if (Object.keys(paragraph)[0] === 'images') {
        return (
          <div key={`paragraph-${sectionIndex}${index}`} className="mb-30">
            <Image images={paragraph.images} />
          </div>
        )
      }

      if (Object.keys(paragraph)[0] === 'caption') {
        return (
          <p
            key={`paragraph-${sectionIndex}${index}`}
            dangerouslySetInnerHTML={{ __html: paragraph.caption }}
            className="text-granite-gray mt-10 mb-20"
          />
        )
      }

      if (Object.keys(paragraph)[0] === 'unorderedList') {
        return (
          <ul
            className="list-disc ml-15"
            key={`paragraph-${sectionIndex}${index}`}
          >
            {paragraph.unorderedList.map((item, listItemIndex) => (
              <li
                className="mb-15"
                key={`paragraph-${sectionIndex}${index}-list-item-${listItemIndex}`}
                dangerouslySetInnerHTML={{ __html: item }}
              />
            ))}
          </ul>
        )
      }

      if (Object.keys(paragraph)[0] === 'video') {
        return (
          <Video
            key={`paragraph-${sectionIndex}${index}`}
            content={paragraph.video}
            theme={theme}
            inline={true}
          />
        )
      }

      if (Object.keys(paragraph)[0] === 'signature') {
        return (
          <div className="mb-170" key={`image-${sectionIndex}${index}`}>
            <div className="max-w-372">
              <Image images={paragraph.signature} />
            </div>
            <p className="font-bold text-18">{paragraph.signature.name}</p>
            <p className="italic text-14">{paragraph.signature.title}</p>
          </div>
        )
      }

      if (Object.keys(paragraph)[0] === 'segment') {
        return (
          <div
            className="mb-170 bg-opacity-10 md:flex p-20"
            style={{ backgroundColor: 'rgba(72, 161, 229, 0.1)' }}
            key={`segment-${sectionIndex}${index}`}
          >
            <h3
              className={`uppercase font-condensed text-24 ${theme.textColor} mb-10 md:mb-0 md:mr-10 w-full max-w-150`}
            >
              {paragraph.segment.side_text}
            </h3>
            <div className="text-granite-gray">
              <p className="mb-10">{paragraph.segment.text}</p>
              <p className="italic text-16">
                <span>{paragraph.segment.announcement[0]}</span>
                <CameraIcon className="inline m-5 mb-10" />
                <span>{paragraph.segment.announcement[1]}</span>
              </p>
            </div>
          </div>
        )
      }
    })
  }

  renderSections() {
    const { theme, pageData } = this.props
    const { sections, intro } = pageData
    const introExists = !!intro

    return sections.map((section, index) => {
      return (
        <div
          className={cx('pt-35 w-full', {
            'border-t border-columbia-gray': introExists,
          })}
          key={`letter-section-${index}`}
        >
          {section.title && (
            <h2
              className={cx(`${theme.textColor} text-18 xl:text-24 border-b-4 mb-30 ${theme.borderColor}`, {
                'flex justify-between items-end': section.sdg
              })}
            >
              {section.title}

              {section.sdg &&
                section.sdg.map((icon, index) => {
                  return (
                    <div
                      key={index}
                      className={cx({
                        'ml-10': index === 0 && section.sdg.length === 1,
                        'mr-10': index === 0 && section.sdg.length > 1,
                      })}
                    >
                      <a className="block pb-5" href="/appendix#un">
                        <Image key={index} images={icon} sdg />
                      </a>
                    </div>
                  )
                })}
            </h2>
          )}
          <Citations className="mb-16" citations={section.citations} />

          {this.renderParagraphs(section, index)}
        </div>
      )
    })
  }

  render() {
    const { shared, currentPage, routes, pageData, theme } = this.props

    return (
      <>
        <Navigation
          navigation={shared.navigation}
          social={shared.social}
          currentPage={currentPage}
          routes={routes}
          theme={theme}
        />
        <Header
          header={shared.header}
          theme={theme}
          currentPage={currentPage}
          routes={routes}
        />

        <div data-label="letter-page-layout">
          <Hero hero={pageData.hero} graphic={pageData.graphic} theme={theme} />

          {pageData.intro && <Intro intro={pageData.intro} theme={theme} />}

          <div className="container px-20">
            <div className="w-full lg:w-2/3 lg:ml-1/3 md:pl-30 flex flex-col items-end">
              <Citations className="w-full" citations={pageData.citations} />
              {this.renderSections()}
            </div>
            <DottedLine className="text-danaher-blue mb-32 w-full max-h-3" />
            {this.renderPagination()}
          </div>
        </div>
      </>
    )
  }
}

export default LetterPageLayout
